
class SearchTrigger extends HTMLElement{
    
    constructor(){
        super();

        const self = this;

        this.search = document.querySelector('[data-search-form]');
        this.escapeArea = document.querySelector('[data-search-escape-area]');

        this.addEventListener('click', this.toggleSearch.bind(this));
        this.escapeArea.addEventListener('click', this.close.bind(this));

        // Handle Enter and Space key presses
        this.addEventListener('keydown', function(event){
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    self.toggleSearch();
                }
        });

        document.addEventListener('keyup', function (e) {
            if (e.key === "Escape") {
                self.close();
            }
        });
    }

    open() {

        event.preventDefault();

        document.querySelector('body').classList.add('overflow-hidden');

        this.search.classList.toggle('is--active');
        document.querySelector('[data-predictive-search-input]').focus();


        // this.openIcon.classList.remove('block');
        // this.openIcon.classList.add('hidden');

        // this.closeIcon.classList.add('block');
        // this.closeIcon.classList.remove('hidden');
    }

    close() {

        event.preventDefault();
        
        document.querySelector('body').classList.remove('overflow-hidden');

        this.search.classList.remove('is--active');
        this.focus();
        // this.search.classList.add('is--active');

        // this.openIcon.classList.add('block');
        // this.openIcon.classList.remove('hidden');

        // this.closeIcon.classList.remove('block');
        // this.closeIcon.classList.add('hidden');
    }

    toggleSearch() {

        console.log('toggleSearch');

        this.search.classList.toggle('is--active');
        this.search.querySelector('[data-predictive-search-input]').focus();
        this.trapFocus();

        // this.openIcon.classList.add('block');
        // this.openIcon.classList.remove('hidden');

        // this.closeIcon.classList.remove('block');
        // this.closeIcon.classList.add('hidden');

        // Target is open
        // if( this.search.classList.contains('is--active') ){
        //     // this.close();
        // }else{
        //     // this.open();
        // }
    }

    trapFocus() {
        var dialog = this.search;
        var firstFocusableElement = dialog.querySelector('[data-predictive-search-input]');

        dialog.addEventListener('keydown', function(e) {
            const allResultsButton = dialog.querySelector('.search-results__cta');
            const clearButton =  dialog.querySelector('.search__form__btn--clear');
            let lastFocusableElement = allResultsButton ? allResultsButton : clearButton;

            if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
                e.preventDefault();
                lastFocusableElement.focus();
            } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
                e.preventDefault();
                firstFocusableElement.focus();
            }
        });
    }
}

customElements.define('search-trigger', SearchTrigger);